<template>
  <div v-if="result">
    <div class="card_labels">
      <h3>文章配置</h3>
      <p class="tip mt-10">企业发布的文章及管理员关注的文章频道会在小程序-知识库-文章中展示<br/>如需正常使用知识库功能，请前往 <strong>小程序-底部导航-知识库</strong> 是否开启</p>
      <div class="card_label_title">已关注频道（长按可拖动展示顺序）</div>
      <div>
        <template v-if="result.follow_channel.length>0">
          <draggable v-model="result.follow_channel" v-bind="{draggable:'.el-tag',animation: 150}"
                @update="datadragEnd" class="draggable-body-list" style="padding: 0">
            <transition-group class="draggable-body">
              <el-tag 
                      :key="tag.id"
                      v-for="(tag,idx) in result.follow_channel"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(idx,tag.id)"
              >{{tag.name}}
              </el-tag>
            </transition-group>
          </draggable>
        </template>
        <p class="whd-gray999" v-if="result.follow_channel.length==0" style="padding-left: 10px; font-size: 12px">暂未关注</p>
      </div>
      <div class="card_consult" v-if="result.all_channel.length>0">
        <div class="card_label_title">频道推荐</div>
        <el-tag type="info" v-for="(item, index) in result.all_channel" :key="index" class="linetages" @click="addLeabel(item)">
          {{item.name}}
        </el-tag>
      </div>
    </div>

    <div class="card_labels">
      <h3>视频配置</h3>
      <div style="margin-top: 20px; color: #2c3e50; font-size: 14px">
        员工视频展示：
        <el-switch
          v-model="result.knowledge_video"
          :active-value="1"
          :inactive-value="0"
          @change="onChangeSwitch">
        </el-switch>
      </div>
      <p class="tip mt-10">开启后，员工发布的视频内容，将展示在知识库视频中</p>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  import draggable from 'vuedraggable';
  export default {
    name: "SettingsKnowledge",
    components: {
      draggable
    },
    data() {
      return {
        result: null,
        value: ''
      };
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
    },
    methods: {
      InitFn(loading) {
        this.axios
            .post(api.knowledge_get, {})
            .then(response => {
              if (response.data.code == 0) {
                this.result = response.data
                loading.close();
              }
            }).catch(() => {});
      },    
      handleClose(tag, id) {
        this.axios
            .post(api.knowledge_del, {channel_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.result.follow_channel.splice(tag, 1);
              } else {
              }
            })
            .catch(response => {
            });
      },
      addLeabel(item) {
        let state = 0
        for (let i in this.result.follow_channel) {
          if (this.result.follow_channel[i].name === item.name) {
            state = 1
          }
        }
        if (state === 1) {
          this.$message({
            message: '频道已经存在',
            type: 'warning'
          });
          return
        }
        this.changeAddLeabel(item.id)
      },
      changeAddLeabel(id) {
        this.axios
            .post(api.knowledge_add, {channel_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn()
              } 
            })
            .catch(response => {
            });
      },
      onChangeSwitch(option) {
        this.axios
            .post(api.knowledge_set, {knowledge_video: this.result.knowledge_video})
            .then(response => {
              
            })
            .catch(response => {
            });        
      },
      // 拖拽排序结束
      datadragEnd(evt) {
        this.axios
            .post(api.knowledge_sort_channel, {channel_arr: this.result.follow_channel})
            .then(response => {})
            .catch(() => {})
      }
    }
  };
</script>

<style scoped>
.draggable-body-list .el-tag{cursor: move;}
</style>